import React from 'react';
import { connect } from 'react-redux';
import { startSetForecastCategories } from '../../actions/globalState';
import PageHeader from '../Header';
import SearchBar from '../SearchBar';
import Profile from '../Profile';
import MapMain from '../MapMain';
import Setting from '../Setting';
import HeaderCombine from '../HeaderCombine';
import MainContent from './MainContent';
import {getDataOfTable} from '../../utils/utils';
import { Layout, Menu, Breadcrumb, Icon, Affix } from 'antd';
import {lineChartOptions, chartDataVertical, pyramidChartOptions, chartDataPyramid,
    makeObjtoArrayTableData, groupReturnedObject, makeObjforPyramidChart, chartHouseholdForecast, chartHouseholdSize} from '../../chart/config';
import { HorizontalBar, Line } from 'react-chartjs-2';
import ChartRenderProp from '../ChartRenderProp';
import YearSlider from './YearSlider';

const { SubMenu } = Menu;
const { Header, Content, Sider } = Layout;

class MainForecastPage extends React.Component {
    state = {
        top: 10
      }
    handleClick = (e) => {
        //console.log('click ', e);
        this.props.startSetForecastCategories(e.item.props.value);
      }
    
    render() {
        console.log('${this.props.populationForecast}', this.props.populationForecast)
        if (this.props.populationForecast === undefined || this.props.populationForecast.data === undefined) {
            return (<div></div>)
        }
        const chartHeader = `${this.props.populationForecast.data[0].geo_type} - ${this.props.populationForecast.data[0].geo_name}`
        const table = this.props.populationForecast.table
        const tableDetails = getDataOfTable(this.props.populationForecast.tables, table)
        let groupBy, tableData, renderComponent, mainRow, dataForPyramidChart, sliderComponent;
        let isVertical = false;
        if(this.props.populationForecast.table === 'pf_agegend') {
            mainRow = 'year'
            groupBy = groupReturnedObject(this.props.populationForecast.data, mainRow,'population')
            tableData = makeObjtoArrayTableData(groupBy, mainRow)
            //console.log('groupBy', groupBy)
            //console.log('tableData', tableData)
            renderComponent = <ChartRenderProp 
                tableName={tableDetails.display_name} 
                header = { () => ( 
                <div>{chartHeader}</div>
                )}
                render = { (setRef) => (
                <Line download={true} redraw={true} 
                data={chartDataVertical(this.props.populationForecast.data, mainRow)} 
                width={800}
                height={354} 
                options={lineChartOptions} 
                ref= {setRef}
            ></Line>
            )} />
            sliderComponent=<div></div>
        } else if (this.props.populationForecast.table === 'pf_householdsize') {
            mainRow = 'year'
            groupBy = groupReturnedObject(this.props.populationForecast.data, mainRow, 'category')
            tableData = makeObjtoArrayTableData(groupBy, mainRow)
            //console.log('groupBy', groupBy)
            //console.log('tableData', tableData)
            renderComponent = <ChartRenderProp 
                tableName={tableDetails.display_name} 
                header = { () => ( 
                <div>{chartHeader}</div>
                )}
                render = { (setRef) => (
                <Line download={true} redraw={true} 
                data={chartHouseholdSize(this.props.populationForecast.data, mainRow)} 
                width={800}
                height={354} 
                options={lineChartOptions} 
                ref= {setRef}
            ></Line>
            )} />
            sliderComponent=<div></div>
        } else if (this.props.populationForecast.table === 'pf_householdnumber') {
            isVertical = true
            mainRow = 'year'
            groupBy = groupReturnedObject(this.props.populationForecast.data, mainRow, 'category')
            tableData = makeObjtoArrayTableData(groupBy, mainRow)
            //console.log('groupBy', groupBy)
           // console.log('tableData', tableData)
            renderComponent = <ChartRenderProp 
                tableName={tableDetails.display_name} 
                header = { () => ( 
                <div>{chartHeader}</div>
                )}
                render = { (setRef) => (
                <Line download={true} redraw={true} 
                data={chartHouseholdForecast(this.props.populationForecast.data, mainRow)} 
                width={800}
                height={354} 
                options={lineChartOptions} 
                ref= {setRef}
            ></Line>
            )} />
            sliderComponent=<div></div>
        } else {
            mainRow = 'category'
            groupBy = groupReturnedObject(this.props.populationForecast.data, mainRow, 'population')
            //console.log('groupBy', groupBy)
            tableData = makeObjtoArrayTableData(groupBy, mainRow)
            //console.log('tableData after groupBy', tableData)
            //console.log('groupBy', groupBy)
            //console.log('tableData', tableData)
            dataForPyramidChart= makeObjforPyramidChart(groupBy)

            renderComponent = <ChartRenderProp 
                tableName={tableDetails.display_name} 
                header = { () => ( 
                <div>{chartHeader}</div>
                )}
                render = { (setRef) => (
                <HorizontalBar download={true} redraw={true} 
                data={chartDataPyramid(groupBy, mainRow)} 
                width={800}
                height={354} 
                options={pyramidChartOptions} 
                ref= {setRef}
            ></HorizontalBar>
            )} />
            sliderComponent= <YearSlider />
        }
        return (
            <Layout>
                <Header>
                    <HeaderCombine showProfile={true} />>
                </Header>
                <Layout>
                    <Sider width={320} style={{ background: '#fff' }}>
                        <Affix offsetTop={this.state.top}>
                            <Menu
                            onClick={this.handleClick}
                            mode="inline"
                            defaultSelectedKeys={['0']}
                            defaultOpenKeys={['sub1']}
                            style={{ height: '100%', borderRight: 0 }}
                            >
                                {
                                    this.props.populationForecast.tables.length === 0 ? 
                                    (<Menu.Item key="1">No Item</Menu.Item>) : 
                                    ( this.props.populationForecast.tables.map((item, index) => {
                                        return <Menu.Item 
                                        key={index} 
                                        value={item.table_ending}
                                        group={item.display_name}
                                        year={this.props.populationForecast.year}
                                        chart_heading={item.display_name}
                                        chart_order_clause={item.chart_order_clause}> {item.display_name}
                                        </Menu.Item>
                                    }))
                                }
                            </Menu>
                        </Affix>
                    </Sider>
                    <Content>
                            <MainContent isVertical={isVertical} mainRow={mainRow} tableData={tableData} populationForecast={this.props.populationForecast}
                            render = { () => (
                                renderComponent
                            )}
                            slider = { () => (
                                sliderComponent
                            )}
                            
                            />   
                    </Content>
                </Layout>
            </Layout>
        )
    };
}

const mapStateToProps = (state) => {
    return {
        populationForecast: state.globalState.populationForecast
    };
};
const mapDispatchToProps = (dispatch) => ({
    startSetForecastCategories: (text) => dispatch(startSetForecastCategories(text))
  });
export default connect(mapStateToProps, mapDispatchToProps)(MainForecastPage);




// WEBPACK FOOTER //
// ./src/components/populationForecast/MainForecastPage.js